import { z } from "zod";

export const passwordSchema = z
	.string()
	.min(8, "Minimum length of 8")
	.regex(/[a-z]/, "Must contain lowercase characters")
	.regex(/[A-Z]/, "Must contain uppercase characters")
	.regex(/[0-9]/, "Must contain numbers")
	.regex(/[^a-zA-Z0-9]/, "Must contain symbols");

export const emailSchema = z.email("Must be a valid email");

export const isValidPassword = (password: string) => {
	return passwordSchema.safeParse(password).success;
};

export const isValidEmail = (email: string) => {
	return emailSchema.safeParse(email).success;
};
